import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c25091c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-item--top" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "button-item--button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "button-item",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("a", {
        class: "button-item--top__title",
        href: _ctx.href
      }, _toDisplayString(_ctx.titleButton), 9, _hoisted_2),
      _createElementVNode("img", {
        src: _ctx.arrowIcon,
        alt: "vector-img",
        class: "button-item--top__icon"
      }, null, 8, _hoisted_3)
    ]),
    (_ctx.isShowLineButtom)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}